import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileCouponsCreditPage.css';

const COUPON_FILTER_COPY = {
  available: 'You currently have no coupons available',
  used: 'You have no used coupons',
  expired: 'You have no expired coupons',
};

const MobileCouponsCreditPage = () => {
  const navigate = useNavigate();
  const [mainTab, setMainTab] = useState('coupons');
  const [couponFilter, setCouponFilter] = useState('available');

  const couponsByFilter = useMemo(() => ({ available: [], used: [], expired: [] }), []);

  const list = couponsByFilter[couponFilter] || [];
  const isEmpty = list.length === 0;

  const goSupport = () => {
    navigate('/my-support');
  };

  return (
    <div className="mcc-page">
      <header className="mcc-header">
        <button type="button" className="mcc-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mcc-title">Coupons and credit</h1>
        <button type="button" className="mcc-support" onClick={goSupport} aria-label="Customer support">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
          </svg>
        </button>
      </header>

      <div className="mcc-main-tabs" role="tablist" aria-label="Coupons or credit">
        <button
          type="button"
          role="tab"
          aria-selected={mainTab === 'coupons'}
          className={`mcc-main-tab ${mainTab === 'coupons' ? 'is-active' : ''}`}
          onClick={() => setMainTab('coupons')}
        >
          Coupons
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={mainTab === 'credit'}
          className={`mcc-main-tab ${mainTab === 'credit' ? 'is-active' : ''}`}
          onClick={() => setMainTab('credit')}
        >
          Credit
        </button>
      </div>

      {mainTab === 'coupons' && (
        <>
          <div className="mcc-chips" role="group" aria-label="Coupon status">
            {(['available', 'used', 'expired']).map((id) => (
              <button
                key={id}
                type="button"
                className={`mcc-chip ${couponFilter === id ? 'is-active' : ''}`}
                onClick={() => setCouponFilter(id)}
              >
                {id.charAt(0).toUpperCase() + id.slice(1)}
              </button>
            ))}
          </div>
          <div className="mcc-body">
            {isEmpty ? (
              <div className="mcc-empty">
                <svg className="mcc-empty-icon" viewBox="0 0 48 48" fill="none" aria-hidden>
                  <rect x="6" y="10" width="36" height="24" rx="2" stroke="currentColor" strokeWidth="1.5" />
                  <path d="M6 18h36" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" />
                  <circle cx="14" cy="26" r="2" fill="currentColor" />
                </svg>
                <p className="mcc-empty-text">{COUPON_FILTER_COPY[couponFilter]}</p>
              </div>
            ) : (
              <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {list.map((c) => (
                  <li key={c.id}>{c.label}</li>
                ))}
              </ul>
            )}
          </div>
        </>
      )}

      {mainTab === 'credit' && (
        <div className="mcc-body">
          <div className="mcc-credit-balance">
            <p className="mcc-credit-amount">₹0.00</p>
            <p className="mcc-credit-hint">Store credit balance</p>
          </div>
          <div className="mcc-credit-actions">
            <button type="button" className="mcc-credit-btn" onClick={() => navigate('/products')}>
              Shop to earn credit
            </button>
            <button type="button" className="mcc-credit-btn" onClick={goSupport}>
              Credit &amp; billing help
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileCouponsCreditPage;
